import * as React from "react";
import DocumentTitle from "react-document-title";
import Grid from "@material-ui/core/Grid";
import { observer } from "mobx-react-lite";
import { TutorsProfilesTable } from "../../features/Tables/TutorsProfilesTable/TutorsProfilesTable";
import { useGetUsers } from "../../helpers/hooks/useGetUsers";
import { UserRoleEnum } from "../../static/enums/UserRole";
import { uiStore } from "../../mobx/stores/UiStore/UiStore";

export const TutorsProfilesPage = observer(() => {
  const { loading } = uiStore;
  useGetUsers({
    role: UserRoleEnum.tutor,
  });

  return (
    <DocumentTitle title={"Преподаватели - Mindset.Digital"}>
      <Grid container spacing={3}>
        <TutorsProfilesTable loading={loading} />
      </Grid>
    </DocumentTitle>
  );
});
